export const converterData = (data: Date) => {
  const dia = String(data.getDate()).padStart(2, "0");
  const mes = String(data.getMonth() + 1).padStart(2, "0"); // getMonth() retorna de 0 a 11
  const ano = data.getFullYear();
  return `${ano}${mes}${dia}`;
};
